<!-- Header -->
<template>
    <div>
        <g-card
        class="card-consultas-produtos"
        margem="20px"
        :expansivel="true"
        :comecaFechado="false"
        >
            <template #cabecalho>
                <div class="header-filtros">
                    <div class="titulo-filtros-cabecalho"> Produtos por Cliente </div>
                    <div class="header-icons">
                        <g-button
                            class="trash-box"
                            tipo="cinza"
                            altura="35px"
                            largura="45px"
                            icone="icone_lixo.svg"
                            tamanhoIcone="15px"
                            somenteIcone
                            :sombreado="false"
                            v-tooltip="'Limpar filtro'"
                            @click="limpar()"
                        />
                        <g-button
                        class="buscar-button-header-filtro"
                        largura="150px"
                        icone="icone_lupa.svg"
                        negritoTexto
                        tamanhoIcone="15px"
                        tamanhoTexto="15px"
                        altura="35px"
                        gap="10px"
                        :sombreado="false"
                        @click="Grid()"
                        >
                            BUSCAR
                        </g-button>
                    </div>
                </div>
            </template>

            <!-- Form Card Produtos por Cliente -->
            <g-form>
                <div class="consultas-produtos-cliente-form espacamento-filtros">
                    <div class="empresa-produtos-cliente label">
                        <div class="titulo-conteudo-filtros"> Unidade </div>
                        <PDropDown
                            v-model="objFiltro.UnidadeId"
                            :options="EmpresaArray"
                            optionLabel="nome"
                            optionValue="id"
                            placeholder="TODAS"
                            class="empresa-input unidade"
                            :filter="true"
                        />
                    </div>

                    <div class="data-faturamento-produtos-cliente label">
                            <div class="titulo-conteudo-filtros"> Data do último faturamento </div>
                            <div class="input-data">
                                <div class="data-inicio">
                                <g-date-input
                                    v-model="objFiltro.DataUltimoFaturamentoMin"
                                    :dataPassadas = "true"
                                    class="inicio-faturamento-input"
                                    placeholderinput="Início"
                                    alturainput = "45px"
                                    largurainput = "100%"
                                    tamanhobotao = "35px"
                                ></g-date-input>
                                </div>
                                <div class="data-periodo"> à </div>
                                <div class="data-termino">
                                <g-date-input
                                    v-model="objFiltro.DataUltimoFaturamentoMax"
                                    :dataPassadas = "true"
                                    class="termino-faturamento-input"
                                    placeholderinput="Término"
                                    alturainput = "45px"
                                    largurainput = "100%"
                                    tamanhobotao = "35px"
                                ></g-date-input>
                                </div>
                        </div>
                    </div>

                    <div class="nome-cliente-produtos-cliente label">
                        <div class="titulo-conteudo-filtros"> Cliente </div>
                        <!-- <PDropDown
                            v-model="objFiltro.ClienteId"
                            :filter="true"
                            :options="ClienteArray"
                            optionLabel="nomeFantasia"
                            optionValue="id"
                            placeholder="Selecione"
                            class="nome-cliente-input"
                            @filter="buscarClientes($event.value)"
                            :filterFields="['razaoSocial','codigoExterno','nomeFantasia','situacao','estadoCidade','cnpj']"
                            >
                            <template #option="slotProps">
                                <cliente-dropdown-item :dadosCliente="slotProps.option"></cliente-dropdown-item>
                            </template>
                        </PDropDown> -->
                        <cliente-dropdown
                            class="nome-cliente-input"
                            @change="ativaClienteAgrupador"
                            v-model="objFiltro.ClienteId"
                            :empresaId="objFiltro.UnidadeId"
                            :representanteId="this.$store.state.representanteSelecionadoId"
                        />
                    </div>

                    <div class="produto-produtos-cliente label">
                        <div class="titulo-conteudo-filtros"> Descrição Produto </div>
                        <PInputText
                            v-model="objFiltro.CodigoProduto"
                            class="codigo-produto-input"
                            placeholder="Descrição"
                        />
                    </div>

                    <!-- <div class="descricao-produto-produtos-estoque label">
                        <div class="titulo-conteudo-filtros"> Descrição do Produto </div>
                        <PInputText
                            class="descricao-produto-input"
                            placeholder="Insira a descrição do produto"

                        />
                    </div> -->

                    <div class="ordenacao-produtos-cliente label">
                        <div class="titulo-conteudo-filtros"> Ordenação </div>
                        <PDropDown
                            v-model="objFiltro.Ordenacao"
                            :options="OrdenacaoArray"
                            optionLabel="text"
                            optionValue="value"
                            class="codigo-ordenacao-input"
                            placeholder="Ordenação"
                        />
                    </div>

                    <div class="nome-produto-produtos-cliente label">
                        <div class="titulo-conteudo-filtros">Produto</div>
                        <PDropDown
                            v-model="objFiltro.NomeProduto"
                            class="nome-produto-input"
                            optionLabel="labelProduto"
                            optionValue="produtoId"
                            placeholder="Insira o nome do produto"
                            @filter="getProduto($event.value)"
                            :filter="true"
                            :options="ProdutoArray"
                        />
                    </div>

                    <div class="data-venda-produtos-cliente label">
                        <div class="titulo-conteudo-filtros"> Data da última venda </div>
                        <div class="input-data">
                            <div class="data-inicio">
                                <g-date-input
                                    v-model="objFiltro.DataUltimaVendaMin"
                                    :dataPassadas = "true"
                                    class="inicio-venda-input"
                                    placeholderinput="Início"
                                    alturainput = "40px"
                                    largurainput = "100%"
                                    tamanhobotao = "35px"
                                ></g-date-input>
                            </div>
                            <div class="data-periodo"> à </div>
                            <div class="data-termino">
                            <g-date-input
                                v-model="objFiltro.DataUltimaVendaMax"
                                :dataPassadas = "true"
                                class="termino-venda-input"
                                placeholderinput="Término"
                                alturainput = "40px"
                                largurainput = "100%"
                                tamanhobotao = "35px"
                            ></g-date-input>
                            </div>
                        </div>
                    </div>

                    <div class="parametros-produtos-cliente label">
                        <div class="titulo-conteudo-filtros parametros-label"> Outros Parâmetros </div>
                        <div class="parametros">
                            <div class="consultar-dados">
                                <PCheckBox :disabled="ClienteAgrupadorAtiva" id="consultar-dados" value="consultar-dados" class="checkbox-consultas" v-model="objFiltro.ConsultarDadosClienteAgrupador" :binary="true"></PCheckBox>
                                <label class="label-checkbox" for="consultar-dados"> Consultar dados do cliente agrupador </label>
                            </div>
  
                        </div>
                    </div>
                </div>
            </g-form>
            <div class="buscar-button-filtro">
                <g-button
                class="buscar-button"
                largura="300px"
                icone="icone_lupa.svg"
                negritoTexto
                tamanhoIcone="15px"
                tamanhoTexto="15px"
                altura="35px"
                gap="10px"
                :sombreado="false"
                @click="Grid()"
                >
                BUSCAR
                </g-button>
            </div>
        </g-card>

        <!-- Card Nenhuma Informação -->
        <g-card :temCabecalho="false" class="" paddingDefault="0 0em 1em">
            <div v-if="ProdutoEncontrado" class="">
                <img
                    class="icone-global-imagemfundo"
                    src="@/assets/imgs/Ilustracao_erro.svg"
                />
                <div class="texto-padrao-imagemfundo">
                    Verifique os filtros e clique em buscar para exibir os resultados
                </div>
                </div>
                <div v-else-if="!ProdutoEncontrado">
                    <g-data-table
                            ref="grid"
                            class="datatable-ReclamacaoTec"
                            Titulo="Dados do Produto"
                            altura="auto"
                            :colunas="Colunas"
                            :valores="InfosArray"
                            :ehExpansivel = "true"
                            :maxWidthExpansivel="'100px'"
                            :Paginacao="true"
                            :NumeroLinhas="100"
                            :Filtros="Filtro"
                            :FiltrosEspecificos = "false"
                            :Editavel= "false"
                            EscondeColunaBotao
                            esconderColunaFrozen
                            :checkprancheta = "false"
                            v-on:duploClickLinha="redirecionaTelaDetalhes"
                            :campoAgrupador="'empresaCliente'"
                            :campoExibicaoGrupo="'empresaCliente'"
                            dataKey="produtoId"


                    >
                        <template #expansivel="slotProps">
                            <g-data-table
                                TextoVazio="Nenhum Componente Encontrado"
                                Titulo="Componente"
                                altura="auto"
                                :valores = "FormataMedidas(slotProps.linha.data.componenteArray)"
                                :colunas="ColunasSubGrid"
                                :NumeroLinhas="2"
                                :Editavel= "false"
                                :Imprimivel= "false"
                                :rowEditor="false"
                                :checkprancheta = "false"
                                :esconderColunaFrozen = "true"
                                :esconderHeader = "true"
                                :FiltrosEspecificos = "false"
                                :FiltroGeral = "false"
                                :Paginacao="false"
                                dataKey="produtoId"
                                >
                            </g-data-table>
                        </template>
                    </g-data-table>
                </div>
        </g-card>


        <!-- <div class="popup-componentes-pedido">
              <PDialog id="popup-componentes" :closable="false" v-model:visible="popup">
                <div class="conteudo-popup-componentes">

                  <table class="tabela-popup-componentes">
                    <tr>
                      <th class="header-tabela-componentes titulo-tabela"> Componentes - </th>
                      <th class="header-tabela-componentes titulo-tabela"> Comprimento x Largura x Altura x Altura da tampa </th>
                    </tr>
                    <tr class="popup-infos" v-for= "(data, index) in componentePedidoArray" :key="data">
                        {{index+1}} .
                      <td class="componente-tabela conteudo-tabela">{{data.componenteTipoTexto}} - </td>
                      <td class="medidas-tabela conteudo-negrito-tabela"> {{data.ColunaMedidas}} </td>
                    </tr>
                  </table>
            </div> -->

                <!-- <div class="botao-componentes">
                  <g-button
                    tipo="amarelo"
                    class="botao-voltar"
                    largura="200px"
                    negritoTexto
                    @click="fecharpopup"
                  >
                  VOLTAR
                  </g-button>
                </div>
              </PDialog>
            </div> -->

    </div>
</template>

<script>
import ProdutosCliente from './ProdutosCliente.js'
export default ProdutosCliente
</script>

<style scoped>
    /* Header */
    .datatable-ReclamacaoTec {
    border-radius: 10px;
    }

    .scroll {
        widows: 10px;
        overflow: scroll;
    }



.card-resultado-content {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  margin-top: 4rem;
}

.header-icons-detalhe {
    display: flex;
    justify-content: flex-end;
}

.conteudo-negrito-tabela {
  color:#4F4C4D;
  font-family: "MontSerrat";
  font-weight: bold;
}

.tabela-popup-componentes{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.popup-infos{
    display: flex;
    justify-content: space-around;
}
.conteudo-tabela {
  color: #6e6e6e;
  font-family: "MontSerrat";
}

.titulo-tabela {
  color: #4f2c19;
  font-family: "MontSerrat";
  font-weight: bold;
  margin-top: 30px;
}

    .botao-componentes {
    display: flex;
    justify-content: center;
    padding-top: 10px;
    }

    .buscar-button-header {
        display: none;
        /* max-width: 125px; */
    }


    /* Div Consultas - Produtos por Cliente */
    .consultas-produtos-cliente {
        padding: 10px;
        /* margin: 0 auto; */
    }


    /* Card Consultas - Produtos por Cliente */
    .card-consultas-produtos-cliente-header {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .card-consultas-produtos-cliente {
        margin-bottom: 25px;
    }

    .card-consultas-produtos-cliente-titulo {
    flex: 1;
    text-align: left;
    color: #4f2c19;
    font-weight: bold;
    font-size: 1.1rem;
    align-self: center;
    }


    /* Form Consultas - Produtos por Cliente */
    .consultas-produtos-cliente-form {
    width: 95%;
    text-align: left;
    display: flex;
    margin: 0 auto;
    margin-top: 3px;
    flex-direction: column;
    align-items: center;
    }

    .empresa-input, .nome-cliente-input, .nome-produto-input, .descricao-produto-input {
        width: 100%;
    }

    .label {
        width: 100%;
    }

    .inicio-faturamento, .termino-faturamento, .inicio-venda, .termino-venda  {
        width: 100%;
    }

    .data-faturamento-input, .data-venda-input {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .produto-produtos-cliente, .ordenacao-produtos-cliente {
        /* margin-top: 10px; */
    }
    .codigo-produto-input {
        width: 85%;
        margin-top: 4px;
    }
    .codigo-ordenacao-input {
        width: 100%;
        margin-top: 4px;
    }

    .g-input-label {
        font-size: 0.85rem;
        padding: 4% 0 3.5% 0;
    }

    .label-checkbox {
        font-size: 14px;
        font-family: "Montserrat";
        color: #8A8A8A;
        margin-left: 1.5%;
    }

    .consultar-dados, .componentes-expandidos {
        display: flex;
        gap: 0.2rem;
    }

    .parametros-produtos-cliente-label {
        padding: 4.5% 0 3% 0;
    }


    /* Card Resultados */
    .card-resultado {
    width: 94vw;
    height: 42vh;
    border-radius: 8px;
    margin: 10px 20px 0 0;
    }

    .card-resultado-text-small {
    font-size: 0.9rem;
    color: #4F4C4D;
    }

    .card-resultado-content {
    width: 80vw;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    margin-top: 4rem;
    }

    .imagem-nenhuma-info {
    margin: 0 auto;
    max-height: 500px;
    }


    /* Busca Button */
    .buscar-button-consulta {
    margin-top: 1.2rem;
    display: flex;
    align-content: center;
    justify-content: center;
    margin-bottom: 15px;
    }

    .parametros {
        display: flex;
        flex-direction: column;
        gap: 0.8rem;
    }

    :deep(.g-card-conteudo) {
        padding: 2;
    }

    .consultas-produtos-cliente-form {
            display: grid;
            grid-template-columns: repeat(2, minmax(6em ,0.5fr));
            grid-template-rows: repeat(7, 115px), 140px;
    }


    /* Medias */
    @media (min-width:310px) {
    .unidade { order: 1 }
    .datatable-ReclamacaoTec {
        text-align: center;
    }
        .label {
            text-align: left;
        }

        .empresa-produtos-cliente { grid-area: 1 / 1 / 2 / 3; }
        .data-faturamento-produtos-cliente { grid-area: 2 / 1 / 3 / 3; }
        .nome-cliente-produtos-cliente { grid-area: 3 / 1 / 4 / 3; }
        .produto-produtos-cliente { grid-area: 4 / 1 / 5 / 2; }
        .ordenacao-produtos-cliente { grid-area: 4 / 2 / 5 / 3; }
        .nome-produto-produtos-cliente { grid-area: 5 / 1 / 6 / 3; }
        .descricao-produto-produtos-cliente { grid-area: 6 / 1 / 7 / 3; }
        .data-venda-produtos-cliente { grid-area: 7 / 1 / 8 / 3; }
        .parametros-produtos-cliente { grid-area: 8 / 1 / 9 / 3; }

        .data-faturamento, .data-venda {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 0.3rem;
        }

        .codigo-produto-input {
            display: flex;
            justify-content: flex-start;
        }

        .card-consultas-produtos-cliente-titulo {
            flex-grow: 1.5;
        }
         .card-consultas-produtos-cliente-header {
            margin: 0px 10px 0px 10px;
        } 
        .card-resultado {
            height: 45vh;
        }


        .buscar-button-consulta {
            width: 100%;
        }

    }

    @media (min-width:368px) {

        /* .buscar-button {
            width: 300px;
        } */
        .consultas-produtos-cliente-form {
            padding: 5px;
            grid-template-rows: repeat(7, 115px), 180px;
        }

        .label {
            text-align: left;
        }

        .empresa-produtos-cliente { grid-area: 1 / 1 / 2 / 3; }
        .data-faturamento-produtos-cliente { grid-area: 2 / 1 / 3 / 3; }
        .nome-cliente-produtos-cliente { grid-area: 3 / 1 / 4 / 3; }
        .produto-produtos-cliente { grid-area: 4 / 1 / 5 / 2; }
        .ordenacao-produtos-cliente { grid-area: 4 / 1 / 5 / 3; }
        .nome-produto-produtos-cliente { grid-area: 5 / 1 / 6 / 3; }
        .descricao-produto-produtos-cliente { grid-area: 6 / 1 / 7 / 3; }
        .data-venda-produtos-cliente { grid-area: 7 / 1 / 8 / 3; }
        .parametros-produtos-cliente { grid-area: 8 / 1 / 9 / 3; }

        .data-faturamento, .data-venda {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .codigo-produto-input {
            display: flex;
            justify-content: flex-start;
        }

        .card-consultas-produtos-cliente-titulo {
            flex-grow: 2;
        }
        /* .card-consultas-produtos-cliente-header {
            margin: 0px 10px 0px 10px;
        } */
        .card-resultado {
            height: 45vh;
        }
    }

    @media (min-width:600px) {

        .consultas-produtos-cliente-form {
            grid-template-rows: repeat(7, 115px), 140px;
        }

        .label {
            text-align: left;
        }

        .empresa-produtos-cliente { grid-area: 1 / 1 / 2 / 3; }
        .data-faturamento-produtos-cliente { grid-area: 2 / 1 / 3 / 3; }
        .nome-cliente-produtos-cliente { grid-area: 3 / 1 / 4 / 3; }
        .produto-produtos-cliente { grid-area: 4 / 1 / 5 / 2; }
        .ordenacao-produtos-cliente { grid-area: 4 / 2 / 5 / 3; }
        .nome-produto-produtos-cliente { grid-area: 5 / 1 / 6 / 3; }
        .descricao-produto-produtos-cliente { grid-area: 6 / 1 / 7 / 3; }
        .data-venda-produtos-cliente { grid-area: 7 / 1 / 8 / 3; }
        .parametros-produtos-cliente { grid-area: 8 / 1 / 9 / 3; }
        .data-faturamento, .data-venda {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .codigo-produto-input {
            display: flex;
            justify-content: flex-start;
        }

        .card-consultas-produtos-cliente-titulo {
            flex-grow: 4;
        }

        .card-resultado {
            height: 41vh;
        }
    }

    @media (min-width:801px) {
        .label {
            text-align: left;
        }

        .empresa-produtos-cliente { grid-area: 1 / 1 / 2 / 3; }
        .data-faturamento-produtos-cliente { grid-area: 2 / 1 / 3 / 3; }
        .nome-cliente-produtos-cliente { grid-area: 3 / 1 / 4 / 3; }
        .produto-produtos-cliente { grid-area: 4 / 1 / 5 / 2; }
        .ordenacao-produtos-cliente { grid-area: 4 / 2 / 5 / 3; }
        .nome-produto-produtos-cliente { grid-area: 5 / 1 / 6 / 3; }
        /* .descricao-produto-produtos-cliente { grid-area: 6 / 1 / 7 / 3; } */
        .data-venda-produtos-cliente { grid-area: 7 / 1 / 8 / 3; }
        .parametros-produtos-cliente { grid-area: 8 / 1 / 9 / 3; }

        .data-faturamento, .data-venda {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .codigo-produto-input {
            display: flex;
            justify-content: flex-start;
        }

        .card-consultas-produtos-cliente-titulo {
            flex-grow: 6;
        }

        .trash-box-consulta {
            margin: 0px 10px 0px 5px;
        }
    }

    @media (min-width:1025px) {
        .consultas-produtos-cliente-form {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-template-rows: repeat(2, 1fr);
            grid-column-gap: 0px;
            grid-row-gap: 0px;
        }

    /* Div Consultas - Produtos por Cliente */
    .consultas-produtos-cliente {
        /* padding: 10px; */
        margin: 0 auto;
    }
        .label {
            text-align: left;
            align-self: flex-end;
        }

        .empresa-produtos-cliente { grid-area: 1 / 1 / 2 / 2; }
        .nome-cliente-produtos-cliente { grid-area: 1 / 2 / 2 / 3; }
        .produto-produtos-cliente { grid-area: 1 / 3 / 2 / 4; }
        .nome-produto-produtos-cliente { grid-area: 1 / 4 / 2 / 6; }
        .descricao-produto-produtos-cliente { grid-area: 1 / 5 / 2 / 6; }
        .data-venda-produtos-cliente { grid-area: 1 / 6 / 2 / 8; }
        .data-faturamento-produtos-cliente { grid-area: 2 / 1 / 3 / 3; }
        .ordenacao-produtos-cliente { grid-area: 2 / 3 / 3 / 5; }
        .parametros-produtos-cliente { grid-area: 2 / 5 / 3 / 7; }

        .codigo-produto-input {
            width: 100%;
        }

        .codigo-produto-input, .codigo-ordenacao-input {
            margin-top: 0px;
        }

        .parametros {
            width: 100%;
            padding-top: 20px;
            padding-bottom: 10px;
            display: inline-flex;
            align-items: center;
        }

        .parametros-label {
            display: inline;
            align-self: flex-start;
        }

        .consultar-dados, .componentes-expandidos {
            width: 50%;
        }

        .card-resultado {
            height: 44vh;
        }

        .card-resultado-text-small {
            font-size: 0.8rem;
            color: #4F4C4D;
        }

        .imagem-nenhuma-info {
            margin: 0 auto;
            height: 190px;
            max-height: 500px;
        }

        /* .header-icons{
            flex-grow: 1;
            align-items: center;
            justify-content: end;
            width: auto;
            margin: 20px 0 20px 0;
        } */

        .buscar-button-consulta{
            display: none;
        }

        .buscar-button-header {
            display: block;
            margin-left: 15px ;
        }

        /* .card-consultas-produtos-cliente-header {
            display: inline-flex;
            width: 105%;
        } */

        .parametros {
            display: flex;
            flex-direction: row;
            gap: 0;
            margin: 0;
            padding-top: 10px;
            padding-bottom: 0;
        }

        .trash-box-consulta {
            margin: 0px 0px 0px 5px;
        }
    }

    @media (min-width:1281px) {
        .consultas-produtos-cliente-form {
            width: 100%;
            grid-template-rows: 50px, 70px;
            grid-column-gap: 20px;
            grid-row-gap: 10px;
            margin-bottom: 2%;
        }

        .label {
            text-align: left;
        }

        .empresa-produtos-cliente { grid-area: 1 / 1 / 2 / 2; align-self: flex-end; }
        .nome-cliente-produtos-cliente { grid-area: 1 / 2 / 2 / 3; align-self: flex-end; }
        .produto-produtos-cliente { grid-area: 1 / 3 / 2 / 4; align-self: flex-end; }
        .nome-produto-produtos-cliente { grid-area: 1 / 4 / 2 / 6; align-self: flex-end; }
        .descricao-produto-produtos-cliente { grid-area: 1 / 5 / 2 / 6; align-self: flex-end; }
        .data-venda-produtos-cliente { grid-area: 1 / 6 / 2 / 8; align-self: flex-end; }
        .data-faturamento-produtos-cliente { grid-area: 2 / 1 / 3 / 3; align-self: flex-end; }
        .ordenacao-produtos-cliente { grid-area: 2 / 3 / 3 / 5; align-self: flex-end; }
        .parametros-produtos-cliente { grid-area: 2 / 5 / 3 / 7; align-self: flex-end; }

        .codigo-produto-input {
            width: 100%;
        }

        .codigo-produto-input, .codigo-ordenacao-input {
            margin-top: 0px;
        }

        .parametros {
            display: inline-flex;
            align-items: center;
        }

        .parametros-label {
            display: inline;
            align-self: flex-start;
        }

        .consultar-dados, .componentes-expandidos {
            width: 50%;
            display: flex;
            gap: 0.5rem;
        }

        .card-resultado {
            height: 44vh;
        }

        .card-resultado-text-small {
            font-size: 0.8rem;
            color: #4F4C4D;
        }

        .imagem-nenhuma-info {
            margin: 0 auto;
            height: 190px;
            max-height: 500px;
        }

        /* .header-icons{
            display: flex;
            align-items: center;
            width: auto;
            justify-content: end;
            margin: 20px 0 20px 0;
        } */

        .buscar-button-consulta{
            display: none;
        }

        .buscar-button-header {
            display: block;
            margin-left: 15px ;
        }

        /* .card-consultas-produtos-cliente-header {
            display: inline-flex;
            width: 105%;
        } */

        .input-data {
            width: 90%;
        }

        :deep(.p-column-title) {
        color: #b5b5b5;
        font-weight: 400;
        white-space: break-spaces;
        }
    }
</style>